import { css } from 'styled-components';

// Converts the breakpoints into styled-components css functions

export default function mediaQueries(breakPoints) {
  return Object.keys(breakPoints).reduce(function (acc, label) {
    acc[label] = function () {
      return css(["@media (min-width:", "em){", ";}"], breakPoints[label], css.apply(void 0, arguments));
    };
    return acc;
  }, {});
}